import React from "react"
import ConstantsProvider from "./ConstantsProvider"
import DiagnosticEducatifProvider from "./DiagnosticEducatifProvider"
import FollowUpProvider from "./FollowUpProvider"
import ForumProvider from "./ForumProvider"
import { PostProvider } from "./PostProvider"
import ProgramProvider from "./ProgramProvider"
import QuizzProvider from "./QuizzProvider"
import GoalProvider from "./GoalProvider"
import { ReminderProvider } from "./ReminderProvider"
import SurveyProvider from "./SurveyProvider"
import VisioContentProvider from "./VisioContentProvider"

const Provider = ({ children }) => {
    return (
        <FollowUpProvider>
            <DiagnosticEducatifProvider>
                <ForumProvider>
                    <QuizzProvider>
                        <ConstantsProvider>
                            <PostProvider>
                                <ProgramProvider>
                                    <VisioContentProvider>
                                        <GoalProvider>
                                            <ReminderProvider>
                                                <SurveyProvider>{children}</SurveyProvider>
                                            </ReminderProvider>
                                        </GoalProvider>
                                    </VisioContentProvider>
                                </ProgramProvider>
                            </PostProvider>
                        </ConstantsProvider>
                    </QuizzProvider>
                </ForumProvider>
            </DiagnosticEducatifProvider>
        </FollowUpProvider>
    )
}

export default Provider
